import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseService } from './services/firebase.service';
import { MyauthService } from './services/myauth.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  email:string='';
  exampleForm: FormGroup;
  validation_messages = {
    'uname': [
      { type: 'required', message: 'E-mail is required!' }
    ],
    'phn': [
      { type: 'required', message: 'Phone Number is required!' }
    ]
  };

  innerWidth:any;
  small:boolean=false;
  
  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.innerWidth=event.target.innerWidth;
    if(this.innerWidth<880){
      this.small=true;
    }
    else this.small=false;
  }

  itemValue = '';

  items:Array<any>;

  userSignedIn:boolean=false;
  buttonName: String='';

  constructor(private router:Router, private fs: FirebaseService, private myauth:MyauthService, private fb: FormBuilder ){

    this.innerWidth= window.innerWidth;
    if(this.innerWidth<880){
      this.small=true;
    }
    else this.small=false;

    this.myauth.signedBro.subscribe(res=>{
      this.userSignedIn=res;
      this.buttonName=(this.userSignedIn)?'Sign Out': 'Sign In';
    });
    this.userSignedIn=this.myauth.isLoggedIn;
    this.buttonName=(this.userSignedIn)?'Sign Out': 'Sign In';
    
    const user = JSON.parse(localStorage.getItem('user'));
    if(user){
      this.email=user.email;
    }
    this.createForm();
  }

  createForm(){
    this.exampleForm = this.fb.group({
      uname: [this.email, Validators.required ],
      phn: ['', Validators.required ],
      message:['']
    });
  }
  goSubmit(value){
    this.fs.addMessage(value);
    alert("Message sent!");
    this.resetFields();
  }

  resetFields(){
    this.exampleForm = this.fb.group({
      uname: new FormControl('', Validators.required),
      phm: new FormControl('', Validators.required),
      message: new FormControl('')
    });
  }

  goPlans(){
    this.router.navigateByUrl('plans');
  }
  goServices(){
    this.router.navigateByUrl('services');
  }
  
  goOrders(){
    this.router.navigateByUrl('orders');
  }
  goMyAccount(){
    window.open('http://portal.purenetindia.com/', '_blank');
  }

  goAbout(){
    this.router.navigateByUrl('about');
  }
  goContact(){
    this.router.navigateByUrl('contact');
  }
  goFeedback(){
    this.router.navigateByUrl('feedback');
  }

  goSignIn(){
    if(this.userSignedIn){
      this.myauth.SignOut();
    }
    else this.router.navigateByUrl('signin');
  }

  goSignOut(){
  }

  goHome(){
    this.router.navigateByUrl('');
  }
  goOption1(){
    this.router.navigateByUrl("bplans");
  }
  goOption2(){
    this.router.navigateByUrl("fplans");
  }

  onSubmit(){
  }
  
}
